export default {
  materialTable: {
    title: '各本體材料性質',
    body: '本體／體積',
    material: '材料',
    allBodies: '所有本體',
    thermalTitle: '各本體熱物性',
    conductivity: 'k (W/(m·K))',
    density: 'ρ (kg/m³)',
    specificHeat: 'cp (J/(kg·K))',
  },
  feaConvergence: {
    stale: '超過一分鐘沒有新迭代。求解器可能仍在處理目前迭代。',
    title: 'FEA 收斂歷程',
    attempt: '求解範圍',
    attemptScope: '步驟 {{step}} · 增分 {{increment}} · 嘗試 {{attempt}}',
    attemptHelp: '步驟、增分與嘗試在求解迴圈中如何巢狀',
    allIncrements: '所有增量',
    iteration: '牛頓迭代',
    iterationAxis: '迭代',
    iterationLabel: '迭代 {{n}}',
    // All-increments 只畫各增量的最終牛頓（ENG-3002），略過約 100% 溫度修正的首步。
    cumulativeIterationAxis: '各增量最終牛頓',
    cumulativeIterationLabel: '最終牛頓 {{n}}',
    waiting: '等待牛頓迭代資料。直接求解可能不產生迭代。',
    notEmitted: '此求解未產生牛頓迭代（直接／線性求解）。',
    unavailable: '沒有可用的收斂歷程。',
    readError: '無法更新收斂歷程，保留最後收到的資料。',
    partial:
      '部分歷程：省略 {{omitted}} 列，無效 {{invalid}} 列。完整紀錄請下載原始求解器檔案。',
    updated: '更新時間 {{time}}',
    calibration: '預緊力校準',
    solve: '最終求解',
    contactCount: '接觸元素：{{count}}',
    targetsUnavailable: '此執行未記錄收斂目標。完成判定仍以求解器為準。',
    targetsDeclared:
      '虛線表示主要收斂準則。多次迭代後可能套用替代殘差準則，因此完成判定仍以求解器為準。',
    met: '已達成',
    notMet: '未達成',
    notAvailable: '無法取得',
    residual_force_percent: '力殘差 (%)',
    correction_displacement_percent: '位移修正 (%)',
    residual_flux_percent: '通量殘差 (%)',
    correction_temperature_percent: '溫度修正 (%)',
    omittedNonpositive:
      '有 {{count}} 個值為 0% 或以下，對數軸無法繪製（第二次牛頓迭代剛好為 0 很常見）。',
    allZeroFinalNewton:
      '{{measures}}：在「所有增量」的每個最終牛頓皆為 0%，對數軸無法繪製。請開啟單一增量以查看該殘差仍在變化的牛頓路徑。',
    allZeroFinalNewtonTip:
      '{{measure}} 在此檢視的每個最終牛頓皆為 0%。請開啟單一增量以查看牛頓路徑。',
    allZeroTip: '{{measure}} 在此範圍的每個牛頓皆為 0%，對數軸無法繪製。',
    allZeroMark: '皆為 0%',
    clippedAbove: '有 {{count}} 個值超出此軸上限，已標在頂端（{{max}}%）。',
    clippedMark: '超出軸',
  },
  table: {
    title: '設計點',
    noMatches: '沒有符合目前篩選條件的設計點。',
  },
  compareGutter: {
    add: '將 {{short}} 加入比較',
    remove: '將 {{short}} 移出比較',
  },
  columns: {
    // Screen-reader-only names for the two columns whose visible
    // header renders nothing (ENG-1733): the row-action column and
    // the 6px left spacer that offsets the sticky index column.
    actions: '操作',
    spacer: '間隔',
    compare: '比較',
    id: 'ID',
    geometry: '幾何檔',
    // 「網格檔」明示為「所用網格檔案」的引用, 與「網格化時間」的「網格」
    // 概念作區隔 — 前者是資產, 後者是動作.
    mesh: '網格檔',
    // 「網格化時間」— 產生此網格所耗費的時間 (meshing duration),
    // 非「網格檔本身的某時間戳」.
    meshTime: '網格化時間',
    meshTimeTooltip: '此設計點的網格產生所耗費的實際時間(從工作開始到完成)。',
    sim: '模擬',
    status: '狀態',
    time: '運算時間',
    timeTooltip:
      '此設計點的求解所耗費的實際時間(從求解器啟動到完成)。排隊中的列顯示目前的排隊等待時間。右鍵點擊標題可切換顯示格式。',
  },
  timeMode: {
    menuLabel: '顯示為',
    elapsed: '經過時間',
    elapsedHint: '實際時間(預設)',
    completedAbsolute: '完成時刻',
    completedAbsoluteHint: '完成的絕對時間',
    completedRelative: '完成',
    completedRelativeHint: '相對於現在的時間(例:5 分鐘前)',
    createdAbsolute: '建立時刻',
    createdAbsoluteHint: '提交的絕對時間',
  },
  columnsMenu: {
    trigger: '欄位',
    allOn: '全部顯示',
    allOnTooltip: '顯示所有欄位',
    allOff: '全部隱藏',
    allOffTooltip: '隱藏所有結果欄位（輸入欄位仍保留）',
    hideNa: '隱藏無資料',
    hideNaTooltip: '隱藏所有設計點皆無數值的欄位',
  },
  groups: {
    designPoint: '設計點',
    mesh: '網格',
    inputs: '輸入',
    run: '執行',
    results: '結果',
    other: '其他',
  },
  statusBar: {
    empty: '沒有設計點',
    rendering: '顯示第 {{from}}–{{to}} 筆，共 {{total}} 筆',
    canonicalOrder: '預設順序',
    sortedBy: '排序依據 {{keys}}',
    asc: '遞增',
    desc: '遞減',
    reset: '重設檢視',
  },
  footer: {
    meanConverged: '平均 · 已收斂 ({{count}})',
  },
  filter: {
    clear: '清除篩選',
  },
  toolbar: {
    exportCsv: '匯出 CSV',
    searchLabel: '依設計點或模擬 ID 搜尋',
    searchPlaceholder: 'id 或 sim…',
    density: '緊密列高',
  },
  header: {
    unitHint: '按右鍵切換單位',
  },
  shortHeaders: {
    force_pressure_x: '壓力 X (N)',
    force_pressure_y: '壓力 Y (N)',
    force_pressure_z: '壓力 Z (N)',
    force_viscous_x: '黏性 X (N)',
    force_viscous_y: '黏性 Y (N)',
    force_viscous_z: '黏性 Z (N)',
    force_normal_mag: '法向 |·| (N)',
    force_tangential_mag: '切向 |·| (N)',
    normal_tangential_ratio: '法向 / 切向 比',
    wall_pressure_min_pa: '壁面 p 最小 (Pa)',
    wall_pressure_max_pa: '壁面 p 最大 (Pa)',
    inlet_flow_rate_m3s: '入口 Q (m³/s)',
    outlet_flow_rate_m3s: '出口 Q (m³/s)',
    inlet_velocity_avg_ms: '入口 U 平均 (m/s)',
    outlet_velocity_avg_ms: '出口 U 平均 (m/s)',
    mass_imbalance_frac: '質量不平衡',
    time_step_count: '步數',
    last_time_step: '最終步',
    execution_time_s: '求解器 (s)',
    solution_unphysical: '非物理',
    divergence_detected: '發散',
  },
  compactHeaders: {
    cm_pitch: 'C_M',
    normal_tangential_ratio: '法向 / 切向 比',
    safety_factor_ultimate: '極限 SF',
    pressure_drop_kinematic: '運動 Δp',
    cd: 'C_D',
    cl: 'C_L',
    force_tangential_mag: '切向力',
    wall_pressure_min_pa: '壁面 p 最小',
    wall_pressure_max_pa: '壁面 p 最大',
    pressure_drop_pa: 'Δp',
    mass_imbalance_frac: '質量不平衡',
    divergence_detected: '發散',
    solution_unphysical: '非物理',
    converged: '收斂',
    iterations: '迭代',
    execution_time_s: '求解 (s)',
    force_pressure_x: '壓力 X (N)',
    force_pressure_y: '壓力 Y (N)',
    force_pressure_z: '壓力 Z (N)',
    force_viscous_x: '黏性 X (N)',
    force_viscous_y: '黏性 Y (N)',
    force_viscous_z: '黏性 Z (N)',
    force_normal_mag: '法向力',
    force_x: 'Fx (N)',
    force_y: 'Fy (N)',
    force_z: 'Fz (N)',
    inlet_velocity_avg_ms: '入口 U',
    outlet_velocity_avg_ms: '出口 U',
    inlet_flow_rate_m3s: '入口 Q',
    outlet_flow_rate_m3s: '出口 Q',
    target_temperature_k: '目標 T',
    chip_t_max_k: '熱源固體',
    cop_frac_lref: 'CoP 比',
    cd_band: 'C_D 帶',
    cl_band: 'C_L 帶',
    cd_drift: 'C_D 漂移',
    cl_drift: 'C_L 漂移',
    temperature_min: 'T 最小',
    temperature_avg: 'T 平均',
    temperature_max: 'T 最大',
    max_displacement: '最大位移',
    safety_factor_yield: '降伏 SF',
    material_ultimate: '極限',
    col_geometry: '幾何',
    col_meshTime: '網格時間',
  },
  compactHeadersTight: {
    normal_tangential_ratio: 'N/T 比',
    pressure_drop_kinematic: 'Δp 運動',
    wall_pressure_min_pa: 'p 最小',
    wall_pressure_max_pa: 'p 最大',
    force_tangential_mag: '切向',
    force_normal_mag: '法向',
    mass_imbalance_frac: 'M 不平',
    divergence_detected: '發散',
    solution_unphysical: '非物',
    target_temperature_k: '目 T',
    max_displacement: 'Δmax',
    execution_time_s: '求解',
    chip_t_max_k: 'T 固',
    col_geometry: '幾何',
    col_meshTime: '網時',
    col_mesh: '網',
  },
  inputLabels: {
    nu: '運動黏度',
    rho: '密度',
    mu: '動力黏度',
    fluid: '流體預設',
    template: '模板',
    flowAxis: '流動方向',
    flowType: '流動類型',
    turbulenceIntensity: '紊流強度',
    turbulentLengthScale: '紊流長度尺度',
    inletVelocity: '入口速度',
    outletPressure: '出口壓力',
    relaxP: '鬆弛因子 (壓力)',
    relaxU: '鬆弛因子 (速度)',
    relaxTurbulence: '鬆弛因子 (紊流)',
    gradScheme: '梯度格式',
    endTime: '結束時間',
    nNonOrthogonalCorrectors: '非正交修正次數',
    writeInterval: '輸出間隔',
    residualControlP: '殘差目標 (壓力)',
    residualControlU: '殘差目標 (速度)',
    referenceArea: '參考面積 (A_ref)',
    referenceChord: '參考弦長 (l_ref)',
  },
  units: {
    heading: '單位',
    rightClickHint: '右鍵點擊可切換單位',
  },
  cell: {
    true: '是',
    false: '否',
  },
  action: {
    viewInMeshgen: '在 MeshGen 中檢視 →',
    download: '下載',
  },
  geometry: {
    openInMeshgen: '在 MeshGen 中開啟 {{label}}',
  },
  meshCell: {
    maxSize: '最大元素尺寸：{{size}} mm',
    maxSizeUnset: '最大元素尺寸：尚未設定',
    cells: '{{value}} 個 3D 網格單元',
    cellsLoading: '網格單元數：載入中',
    cellsUnavailable: '網格單元數：無法取得（網格仍在執行或未輸出數量）',
  },
  // 狀態篩選彈出視窗使用的 DesignPointStatus 標籤 (ENG-1744). 先前直接
  // 顯示線傳列舉值, 僅把底線換成空白. 這些項目出現在核取方塊清單中,
  // 因此統一使用簡短用詞.
  dpStatus: {
    pending: '待處理',
    preprocessing: '前處理中',
    meshing: '網格化中',
    meshReady: '網格就緒',
    facesDone: '已命名面',
    simulating: '模擬中',
    extracting: '擷取中',
    pendingReview: '等待審查',
    completed: '執行結束',
    failed: '失敗',
    cancelled: '已取消',
  },
  phaseLabel: {
    failedInMesh: '網格階段失敗',
    failedInSim: '模擬階段失敗',
    cancelled: '已取消',
    done: '完成',
    simulating: '模擬中',
    meshing: '網格化中',
    skipped: '已略過',
    queued: '排隊中',
    stopped: '已停止',
  },
  liveDuration: {
    queued: '排隊中 · {{duration}}',
    queuedTooltip: '等待案例啟動。求解器開始後，計時器將切換為已用模擬時間。',
  },
  attemptHistory: {
    run: '執行 {{n}} / {{total}}',
    createdAt: '建立於 {{time}}',
    submittedAt: '提交至求解器佇列於 {{time}}',
    submittedUnknown: '無求解器提交時間',
    startedAt: '求解器開始於 {{time}}',
    endedAt: '結束於 {{time}}',
    queueWait: '佇列等待 {{duration}}',
    iterations_one: '{{count, number}} 次迭代',
    iterations_other: '{{count, number}} 次迭代',
    iterationsTotal_one: '共 {{count, number}} 次迭代',
    iterationsTotal_other: '共 {{count, number}} 次迭代',
    continuedFrom: '接續 {{time}} 停止的執行',
    increments_one: '{{count}} 個增量',
    increments_other: '{{count}} 個增量',
    cutbacks_one: '{{count}} 次回切',
    cutbacks_other: '{{count}} 次回切',
    aiAutoBadge: 'AI · 自動',
    aiManualBadge: 'AI · 手動',
    succeededFlag: '成功',
    originalRun: '首次執行',
    diagnosisHeading: '診斷',
    changesHeading: '變更內容',
    changeReasonPrefix: '原因:',
    sopVersion: '重試規則 v{{v}}',
    copy: '複製',
    copied: '已複製',
    copyTooltip: '以純文字複製完整嘗試紀錄，可直接貼到聊天或訊息中。',
    logHeader: '嘗試紀錄 · 案例 {{id}}',
  },
  decisions: {
    heading_one: '重試判斷',
    heading_other: '重試判斷',
    badge_one: '{{count}} 項判斷',
    badge_other: '{{count}} 項判斷',
    reasonPrefix: '原因：',
    verdict: {
      retry: '重試',
      escalate: '轉交人員處理',
      decline: '不重試',
    },
    lifecycle: {
      proposed: '已提出',
      dispatched: '已派送',
      dismissed: '已駁回',
      approved: '已核准',
    },
    confidence: {
      low: '低',
      medium: '中',
      high: '高',
    },
    reason: {
      semanticFailure: '此失敗無法透過調整參數解決',
      advisorDeclined: '顧問未提出變更建議',
      lowConfidence: '建議的信心度未達門檻',
      advisorInvalid: '顧問回傳了無法使用的建議',
      advisorTimeout: '顧問未在時限內回應',
      validationFailed: '建議的參數未通過驗證',
      previouslyTried: '相同的變更先前已嘗試過',
      capExhausted: '已達自動重試次數上限',
      gciIneligible: '此設計點不適用自動重試',
      advisorNotEntitled: '此工作區或使用者沒有重試顧問的使用權限',
      engineerRerun: '工程師以未變更的設定重新執行',
    },
  },
  residualChart: {
    title: '殘差收斂',
    loading: '正在載入收斂資料…',
    notAvailable: '此次執行沒有殘差資料。',
    awaitingFirstFlush: '等待solver的第一批疊代…',
    notApplicableSolver:
      '此求解器不會輸出殘差歷程。收斂是在求解器日誌中以每個增量回報,而非逐場殘差。',
    noIterationsEmitted: '此次執行在solver產出任何疊代前就失敗了。',
    divergedNan: '發散（NaN/Inf）',
    diverging: '發散中',
    iterationAxis: '迭代',
    iterationLabel: '迭代 {{n}}',
    convergeExitThreshold: '收斂退出閾值',
    convergeExitThresholdTooltip:
      '虛線：此方程式需達到的殘差目標，求解器才會判定收斂並退出。在執行因迭代／時間上限停止、尚未達標時顯示。',
    residualTarget: '殘差目標',
    residualTargetTooltip:
      '虛線：此方程式被設定的殘差目標。此次執行在達標前已發散——請將每條曲線與其虛線對照。',
    convergeExitShort: '收斂退出',
    residualTargetShort: '殘差目標',
  },
  masterTable: {
    rowOf: '第 {{current}} 列，共 {{total}} 列',
    rowCount: '{{count}} 列',
    headerHintSort: '{{label}} · 按一下排序',
    headerHintUnits: '{{label}} · 按一下排序 · 按右鍵切換單位',
    simCellTitle: '模擬 {{sim}} · 第 {{attempt}} 次嘗試 (共 {{total}} 次)',
  },
  withDetail: {
    reopenTooltip: '重新開啟詳細資料（Enter）',
  },
  strip: {
    regionLabel: '設計點',
    count_one: '{{count}} 個',
    count_other: '{{count}} 個',
    expandLabel: '顯示所有設計點',
    rowLabel: '#{{n}} {{short}} · {{status}}',
    compare: '比較已選取的點…',
  },
  jumpStrip: {
    regionLabel: '跳至章節',
    jumpTo: '跳至：',
    newBadge: '新',
    pendingTooltip: '尚未提供 — 等待執行完成。',
    visualization: '視覺化',
    residual: '殘差圖',
    feaConvergence: '收斂圖',
    lineProbe: '線探測',
    feaSetup: '設定',
    inputs: '輸入',
    results: '結果',
    massInertia: '質量與慣性',
    failureDetail: '失敗詳情',
    attemptHistory: '嘗試歷史',
    metadata: '中繼資料',
    verification: '驗證',
    sandbox: '沙盒',
    sandboxHandCalc: '手算',
    sandboxConsistency: '一致性檢查',
    sandboxPlotting: '繪圖組',
  },
  emptyDetail: {
    title: '選取一個設計點',
    description: '按一下任一列，即可在此檢視輸入、結果與殘差收斂。',
    firstFailure: '第一個失敗',
    bestSoFar: '目前最佳',
    firstRow: '第一列',
    kbdStep: '切換',
    kbdClose: '關閉',
    kbdReopen: '重新開啟上一個',
  },
  section: {
    resultFieldOnGeometry: '物體表面上的流場',
    resultTemperatureOnGeometry: '物體表面上的溫度',
    resultFieldOnModel: '模型上的{{field}}',
    resultFeaHeatmap: '應力 / 位移熱圖',
    feaSetup: '設定 — 拘束與載重',
    feaSetupThermal: '設定 — 熱邊界條件',
    residualConvergence: '殘差收斂',
    lineProbe: '沿線物理量',
    inputs: '輸入',
    results: '結果',
    massInertia: '質量與慣性',
    failureDetail: '失敗詳情',
    attemptHistory: '嘗試記錄',
    metadata: '中繼資料',
    files: '檔案',
    sandbox: '沙盒',
  },
  meshInfo: {
    elementType: '元素類型',
    strategy: '策略',
    maxSize: '最大尺寸',
    minSize: '最小尺寸',
    elementOrder: '元素階數',
    cells: '網格單元',
    boundaryLayer: '邊界層',
    skewnessMax: '偏斜度（最大）',
    aspectRatioMax: '長寬比（最大）',
    bodySurfaceArea: '物體表面積',
    inletArea: '入口面積',
    outletArea: '出口面積',
    enclosureArea: '外圍面表面積',
    projectedFrontalArea: '投影正面積 ({{axis}})',
    bodyBbox: '物體外接盒 (X × Y × Z)',
    enclosureBbox: '外圍外接盒 (X × Y × Z)',
    bodyVolume: '物體體積',
    enclosureVolume: '外圍體積',
  },
  meshInfoTooltip: {
    bodySurfaceArea:
      '物體壁面的總濕潤面積. 不包含外圍面 (外流) 或入口 / 出口面.',
    inletArea: '入口面的總面積.',
    outletArea: '出口面的總面積.',
    enclosureArea: '外圍面總面積 (外流) — 非物體、非入口、非出口的所有面合計.',
    projectedFrontalArea:
      '物體投影至流動方向的面積:  A_frontal = ½ · Σ A_i · |n_i · a_flow|,  對每個壁面 i 求和 (A_i = 面積, n_i = 外向法線, a_flow = 流動軸單位向量). ½ 是為了讓封閉物體只計一次 — |n · a| 會同時抓到正面與背面. 為 C_D / C_L 的推薦參考面積.',
    bodyBbox: '直接在匯入的 CAD 上量測的物體軸對齊外接盒 (mm).',
    enclosureBbox:
      '外圍的 X / Y / Z 尺寸 — 由所有面形心的極值推導. 軸對齊外圍可精確還原.',
    bodyVolume:
      'CAD 物體的體積 (各實體的 OCC 體積合計). 幾何摘要無數值時 (診斷前 / trimesh 回退 STL) 將回退至壁貼片的發散定理求和.',
    enclosureVolume:
      '外圍體積, 使用發散定理  V = ⅓ · Σ (c_i · n_i) · A_i  對每個外圍面 i 求和 (c_i = 形心, n_i = 外向單位法線, A_i = 面積).',
  },
  meta: {
    simulationId: '模擬 ID',
    meshId: '網格 ID',
    geometryId: '幾何模型',
    designPointLabel: '設計點標籤',
    meshTags: '網格標籤',
    status: '狀態',
    created: '建立',
    started: '開始',
    completed: '完成',
  },
  massProperties: {
    component: '元件',
    material: '材料',
    volume: '體積 (m³)',
    mass: '質量 (kg)',
    comX: '質心 x (m)',
    comY: '質心 y (m)',
    comZ: '質心 z (m)',
    ixx: 'Ixx (kg·m²)',
    iyy: 'Iyy (kg·m²)',
    izz: 'Izz (kg·m²)',
    ixy: 'Ixy (kg·m²)',
    ixz: 'Ixz (kg·m²)',
    iyz: 'Iyz (kg·m²)',
    kx: 'kx (m)',
    ky: 'ky (m)',
    kz: 'kz (m)',
  },
  partial: {
    title: '部分結果',
    body: '這次執行在完成前就停止了。以下數值來自它最後儲存的步驟（第 {{step}} 步），並非最終答案，也尚未經過檢查。',
    bodyTime:
      '這次執行在完成前就停止了。以下數值來自它最後儲存的時間點（模擬時間 {{step}} 秒），並非最終答案，也尚未經過檢查。',
    bodyIncrement:
      '這次執行在完成前就停止了。以下數值來自實際解出的最後一個載重步（增量 {{step}}），並非最終答案，也尚未經過檢查。',
    bodyNothingRecovered:
      '這次執行在完成前就停止了，且無法復原任何結果。以下的失敗細節就是全部資訊。',
    bodyNoStep:
      '這次執行在完成前就停止了。以下數值來自它最後儲存的步驟，並非最終答案，也尚未經過檢查。',
    sourceLatestTime: '流場與溫度場來自該步驟。',
    sourceLastIncrement:
      '應力與位移來自實際解出的那部分載重，而非你指定的完整載重。',
    sourceUnknown: '',
  },
  detail: {
    prev: '上一個設計點（↑）',
    next: '下一個設計點（↓）',
    viewAttempt: '檢視執行',
    viewCurrentAttempt: '檢視最新嘗試',
    attemptLoading: '正在載入這次嘗試的已儲存結果…',
    attemptLoadFailed: '無法載入這次嘗試的已儲存結果。',
    historicalHandCalc: '手算只儲存在最新嘗試。請選取最新嘗試以檢視。',
    indexOf: '#{{current}}，共 {{total}}',
    runProgressLabel: '計算進度',
    runProgressIterations: '迭代 {{done}} / {{target}}',
    runProgressSeconds: 't = {{done}} / {{target}} 秒',
    runProgressRunning: '執行中',
    openInMeshgen: '在 MeshGen 中開啟',
    inputCase: '輸入案例',
    inputCaseTooltip:
      '下載求解前的輸入檔。求解器原始輸出與監測資料位於嘗試歷程中的結果下載。',
    output: '輸出',
    outputTooltip: '下載輸出（結果與求解器記錄）',
    close: '關閉詳細資料（Esc）',
    stopLimit: {
      iterationLimit: '迭代上限',
      timeLimit: '時間上限',
    },
    download: '下載',
    tagSweep: '掃描',
    tagManual: '手動',
    outcomeConverged: '已收斂',
    outcomeVerified: '已驗證',
    outcomeVerifiedByReviewer: '審查者已驗證',
    outcomeStopped: '已停止',
    outcomeGuide: '執行狀態說明',
    outcomeExplanations: {
      verified:
        '已完成且通過全部適用自動檢查，或編輯者已確認剩餘檢查（含透過核准手算關係）。求解器結果不變。',
      reviewed: '編輯者已確認列出的未解決檢查；求解器結果並未更改。',
      converged:
        '未發散即完成。全面驗證可能仍未完成——請檢查記錄的收斂狀態，或使用審查驗證確認剩餘限制。',
      stopped: '在求解完成前達到時間上限。有儲存檢查點時可以繼續。',
      diverged: '數值計算失敗，無法取得可靠的解。',
      failed: '因其他原因結束，未取得可用的解。請查看失敗詳情。',
    },
    outcomeCompleted: '已完成',
    outcomeDiverged: '已發散',
    outcomeFailed: '失敗',
    outcomeTooltip:
      '「已驗證」表示執行已完成且通過適用驗證，或編輯者已確認剩餘限制。「已收斂」是未發散完成執行的暫用標籤，包含量測上未收斂與達迭代上限的情況。「已發散」表示數值失敗；「失敗」表示因其他原因結束；「已停止」表示達到時間上限。只有已儲存檢查點的執行可以繼續。',
    fullSolverSetup: '完整提交的求解器設定（初始與載荷條件）',
    failedVerification:
      '此執行在取得已驗證解之前失敗。已記錄的殘差或最後一步數值屬於部分診斷資料，不代表通過驗證。',
    best: '最佳',
    logAxisTooltip:
      'Y 軸採用對數刻度。殘差在收斂過程中會下降數個數量級（例如 1e0 → 1e-6），若使用線性軸在接近零時會顯得平坦 — 對數刻度使軌跡更易判讀。',
    yAxisLog: 'y 軸：對數',
    noSimulationYet: '尚無模擬 — 執行開始後即會顯示收斂資料。',
    parameterCount: '{{count}} 個參數',
    resultsHint: '按右鍵切換單位',
    massInertiaHint: '繞質心、全域軸',
    componentMassProperties: '元件屬性（各元件質心、全域軸）',
    componentMassUnavailable:
      '此舊版幾何沒有元件質量屬性。請重新診斷並執行，以產生各元件慣性。',
    resultsHintWithFrontier: '對比前沿最佳 · 按右鍵切換單位',
    noValues: '沒有可顯示的數值。',
    attemptCount: '{{count}} 次嘗試',
    noAttempts: '尚無嘗試。',
    filesEmpty: '尚無模擬嘗試 — 模擬執行後即會顯示檔案。',
    attemptLabel: '第 {{n}} 次嘗試',
    retryWithAi: '用 AI 重試',
    retryWithAiTooltip:
      'Khorium 的代理會檢視此案例的設定與失敗詳情，調整求解器設定後重新執行。',
    retryQueuedToast: '已送出重試 — 代理已將第 {{n}} 次嘗試排入佇列。',
    retryFailedToast: '無法開始重試: {{message}}',
    retryAnyway: '仍然重試',
    retryAnywayTooltip: '以相同設定再執行一次，不套用顧問的修改',
    retryAnywayQueuedToast:
      '已送出重試 — 已以相同設定將第 {{n}} 次嘗試排入佇列。',
    autoRetryFailedToast: '無法更新自動重試: {{message}}',
    continueRun: '繼續執行',
    continueRunTooltip: '提高迭代或時間上限，讓這次執行從停下的地方繼續',
    continueQueuedToast: '已繼續執行 — 會從停下的地方接著跑。',
    continueFailedToast: '無法繼續執行: {{message}}',
    continueOutcomeUnknownToast:
      '無法確認是否已繼續執行。正在重新整理設計點，以顯示目前的狀態。',
  },
  continueDialog: {
    title: '繼續這次執行',
    iterationLimit:
      '這次執行在穩定之前就達到迭代上限（第 {{checkpoint}} 次迭代）。繼續執行會從那裡接著跑，而不是從頭開始。',
    timeLimit:
      '這次執行的時間用完了。繼續執行會從停下的地方接著跑，而不是從頭開始。',
    postprocessTimeLimit:
      '這次執行的時間用完了，之後也無法讀取結果。繼續執行會從停下的地方接著跑並重新讀取結果，而不是從頭開始。',
    postprocessFailed:
      '這次執行已經完成，但無法讀取結果。繼續執行會從最後存檔的地方接著跑並重新讀取結果，而不是從頭開始。',
    reachedIterationLimit:
      '這次執行已達到迭代上限（第 {{checkpoint}} 次迭代）。請提高迭代上限繼續執行，從那裡接著跑，而不是從頭開始。',
    convergedAtIterationLimit:
      '這次執行在達到迭代上限（第 {{checkpoint}} 次迭代）時沒有發散，因此視為已收斂。提高迭代上限繼續執行，就能從那裡接著迭代，而不是從頭開始。',
    reachedEndTime:
      '這次執行已達到迭代上限（第 {{checkpoint}} 次迭代），但無法讀取結果。請提高迭代上限，從那裡接著跑，而不是從頭開始。',
    interrupted:
      '這次執行還沒跑完就被中斷了——是執行的機器消失了，不是你的設定有問題。繼續執行會從最後存檔的地方接著跑，而不是從頭開始。',
    iterations: '新的迭代上限',
    iterationsHint: '必須大於執行停下時的 {{checkpoint}}。',
    cancel: '取消',
  },
} as const;
